import { useEffect, useState } from "react";
import { getAllRolesAPI } from "../../../Redux/Apis/roleApi";
import { useDispatch, useSelector } from "react-redux";
import { checkPermission, permissionType } from "../../../app/utils/common/Functions";
import PageContainerHeader from "../../molecules/PageContainerHeader/PageContainerHeader";
import EditIcon from "../../../assets/icon/edit.png";
import AddRoleDrawer from "../../molecules/AddRoleDrawer/AddRoleDrawer";
import Loader from "../../atoms/Loader/Loader";



const AllRolePage = () => {
    const {isRoleUpdated,roles,loading}=useSelector(state=>state.role);
    const [roleDrawer,setRoleDrawer] = useState(false);
    const dispatch=useDispatch();
    const [selectedRole,setSelectedRole] = useState(null);
    const canUpdateRole = checkPermission(permissionType.ROLE_MANAGEMENT, "update");
    useEffect(()=>{
        if(isRoleUpdated)
        dispatch(getAllRolesAPI())
    },[isRoleUpdated])
    return (
        <div>
            <div className="mb-4">
                <h1 className="page-title">Roles & Access</h1>
                <p className="page-subtitle">Configure team roles and permission boundaries.</p>
            </div>
            <div>
            <PageContainerHeader title='Roles' button={checkPermission(permissionType.ROLE_MANAGEMENT,"create")} buttonTitle={"Add Role"} onclickDrawer={() => {setSelectedRole(null);setRoleDrawer(pre=>!pre) }} />
            </div> 
            {loading ? <Loader /> :
            <>
            <div className="card-border card-body">
            <table className='table-default w-full'>
                <thead>
                    <tr className='text-left'>
                        <th className="!text-[#5d6c89]">#</th>
                        <th className="!text-[#5d6c89]">Role Name</th>
                        {canUpdateRole && <th className="!text-[#5d6c89]">Action</th>}
                    </tr>
                </thead>
                <tbody>
                    {roles.map((role,index)=>( role.roleId!==1 &&
                        <tr key={role.roleId}>
                            <td className="!text-[#1f2b44] font-semibold">{index+1}</td>
                            <td className="!text-[#1f2b44] font-semibold">{role.roleName}</td>
                            {canUpdateRole && (
                              <td>
                                <div className="cursor-pointer p-2 hover:text-blue-500 h-10 flex justify-center items-center w-full">
                                  <img src={EditIcon} alt='edit' className="w-5 h-5" onClick={()=>{setSelectedRole(role);setRoleDrawer(pre=>!pre)}} />
                                </div>
                              </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
            {roleDrawer && <AddRoleDrawer role={selectedRole} isOpen={roleDrawer} toggleLeaveDrawer={()=>setRoleDrawer(false)} />}
            </>
                }
        </div>
    )
}

export default AllRolePage;